import { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import "./BuyPlan.css";
import greentick from "../../images/LandingPageImage/greentickfeature.svg";
import usePlans from "../../services/LandingPage/usePlans";
import useRegistration from "../../services/LandingPage/useGetStarted";
import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";

const BuyPlan = () => {
  const { registerUser, verifyOTP } = useRegistration();

  const location = useLocation();

  const { planId } = useParams();
  const { plans, loading } = usePlans("IN");

  const [selectedPlan, setSelectedPlan] = useState(null);
  const [showBuyPlanDetails, setshowBuyPlanDetails] = useState(false);
  const [countryCode, setCountryCode] = useState("");
  const [showTrialForm, setShowTrialForm] = useState(false);
  const [showBuyPlanForm, setShowBuyPlanForm] = useState(false);

  const openBuyPlanForm = () => {
    setShowBuyPlanForm(true);
    setshowBuyPlanDetails(false);
    setShowTrialForm(false);
  };

  // ##################### Buy Plan Registration #########################
  const [buyplanFormData, setBuyplanFormData] = useState({
    buyplanFirstName: "",
    buyplanLastName: "",
    buyplanEmail: "",
    countryCode: "+91",
    mobileNo: "",
    buyplanDob: "",
    buyplanGender: "",
    buyplanPassword: "",
    buyplanConfirmPassword: "",
  });
  const [buyplanFormErrors, setBuyplanFormErrors] = useState({});
  const [buyplanFormStep, setBuyplanFormStep] = useState(1);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleBuyplanInputChange = (e) => {
    const { name, value } = e.target;
    setBuyplanFormData({ ...buyplanFormData, [name]: value });

    setBuyplanFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const toggleShowConfirmPassword = () =>
    setShowConfirmPassword(!showConfirmPassword);

  const validateBuyplanForm = () => {
    const errors = {};

    // Validation for Step 1
    if (buyplanFormStep === 1) {
      if (!buyplanFormData.buyplanFirstName) {
        errors.buyplanFirstName = "First Name is required";
        setBuyplanFormErrors(errors);
        toast.error("First Name is required");
        return;
      }

      if (!buyplanFormData.buyplanLastName) {
        errors.buyplanLastName = "Last Name is required";
        setBuyplanFormErrors(errors);
        toast.error("Last Name is required");
        return;
      }

      if (!buyplanFormData.buyplanEmail) {
        errors.buyplanEmail = "Email is required";
        setBuyplanFormErrors(errors);
        toast.error("Email is required");
        return;
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
          buyplanFormData.buyplanEmail,
        )
      ) {
        errors.buyplanEmail = "Invalid email address";
        setBuyplanFormErrors(errors);
        toast.error("Invalid email address");
        return;
      }

      if (!buyplanFormData.countryCode) {
        errors.countryCode = "Country code is required";
        setBuyplanFormErrors(errors);
        toast.error("Country code is required");
        return;
      }

      if (!buyplanFormData.mobileNo) {
        errors.mobileNo = "Mobile number is required";
        setBuyplanFormErrors(errors);
        toast.error("Mobile number is required");
        return;
      } else if (!/^\d{10}$/.test(buyplanFormData.mobileNo)) {
        errors.mobileNo = "Invalid mobile number. Must be 10 digits.";
        setBuyplanFormErrors(errors);
        toast.error("Invalid mobile number. Must be 10 digits.");
        return;
      }

      if (!buyplanFormData.buyplanDob) {
        errors.buyplanDob = "Date of Birth is required";
        setBuyplanFormErrors(errors);
        toast.error("Date of Birth is required");
        return;
      }

      if (!buyplanFormData.buyplanGender) {
        errors.buyplanGender = "Gender is required";
        setBuyplanFormErrors(errors);
        toast.error("Gender is required");
        return;
      }
    }

    // Validation for Step 2
    else if (buyplanFormStep === 2) {
      if (!buyplanFormData.buyplanPassword) {
        errors.buyplanPassword = "Password is required";
        setBuyplanFormErrors(errors);
        toast.error("Password is required");
        return;
      } else if (buyplanFormData.buyplanPassword.length < 6) {
        errors.buyplanPassword = "Password must be at least 6 characters long";
        setBuyplanFormErrors(errors);
        toast.error("Password must be at least 6 characters long");
        return;
      }

      if (!buyplanFormData.buyplanConfirmPassword) {
        errors.buyplanConfirmPassword = "Confirm Password is required";
        setBuyplanFormErrors(errors);
        toast.error("Confirm Password is required");
        return;
      } else if (
        buyplanFormData.buyplanPassword !==
        buyplanFormData.buyplanConfirmPassword
      ) {
        errors.buyplanConfirmPassword = "Passwords do not match";
        setBuyplanFormErrors(errors);
        toast.error("Passwords do not match");
        return;
      }
    }

    setBuyplanFormErrors(errors);

    if (Object.keys(errors).length > 0) {
      toast.error("Please fix the highlighted errors.");
    }

    return Object.keys(errors).length === 0;
  };

  const handleBuyplanFormContinue = async (e) => {
    e.preventDefault();

    if (validateBuyplanForm()) {
      if (buyplanFormStep === 1) {
        setBuyplanFormStep(2);
      } else if (buyplanFormStep === 2) {
        const requestBody = {
          firstName: buyplanFormData.buyplanFirstName,
          lastName: buyplanFormData.buyplanLastName,
          countryCode: buyplanFormData.countryCode,
          mobileNo: buyplanFormData.mobileNo,
          emailId: buyplanFormData.buyplanEmail,
          dob: buyplanFormData.buyplanDob,
          gender: buyplanFormData.buyplanGender,
          password: buyplanFormData.buyplanPassword,
          isTrial: "false",
        };

        try {
          const response = await registerUser(requestBody);

          if (response.responseCode === "00") {
            toast.success(response.responseMessage);
            setBuyplanFormStep(3);
          } else {
            toast.error(response.responseMessage || "Failed to purchase plan.");
          }
        } catch (error) {
          toast.error("Failed to purchase plan.");
        }
      }
    }
  };

  const handleBuyplanFormBack = () => setBuyplanFormStep(1);

  const clearForm = () => {
    setBuyplanFormData({
      buyplanFirstName: "",
      buyplanLastName: "",
      buyplanEmail: "",
      countryCode: "+91",
      mobileNo: "",
      buyplanDob: "",
      buyplanGender: "",
      buyplanPassword: "",
      buyplanConfirmPassword: "",
    });
    setBuyplanFormErrors({});
    setBuyplanFormStep(1); // Reset step to 1 if needed
  };

  // Step 3: New OTP verification function
  const handleOTPVerification = async () => {
    if (!buyplanFormData.otp) {
      setBuyplanFormErrors((prev) => ({
        ...prev,
        otp: "OTP is required",
      }));
      toast.error("OTP is required");
      return;
    }

    try {
      const response = await verifyOTP({
        otp: buyplanFormData.otp,
        mobile: buyplanFormData.mobileNo,
      });

      if (response.responseCode === "00") {
        clearForm();
        const token = response.response;
        const callbackUrl = "https://www.anlook.com/identity";

        window.location.href = `${callbackUrl}?accessToken=${token}`;
      } else {
        toast.error(response.responseMessage || "Invalid OTP");
      }
    } catch {
      toast.error("OTP verification failed");
    }
  };

  useEffect(() => {
    if (location.state?.plan) {
      setSelectedPlan(location.state.plan);
      setCountryCode(location.state.countryCode || "IN");
      setshowBuyPlanDetails(true);
    }
  }, [location.state]);

  useEffect(() => {
    if (plans.length > 0 && planId) {
      const foundPlan = plans.find((p) => String(p.id) === String(planId));

      if (foundPlan) {
        setSelectedPlan(foundPlan);
        setshowBuyPlanDetails(true);
      }
    }
  }, [plans, planId]);

  if (loading || !selectedPlan) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p>Loading plan details...</p>
      </div>
    );
  }

  return (
    <>
    <ToastContainer/>
  
    <div className="vertical-height-100">

      {/* Buy Plan Details Screen */}
      {showBuyPlanDetails && selectedPlan && (
        <div className="min-h-screen bg-gradient-to-br from-green-50 to-white flex items-center justify-center p-4">
          <div className="w-full max-w-2xl bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className="bg-green-600 text-white text-center py-4 text-xl font-semibold">
              Plan Details
            </div>

            <div className="p-6 space-y-6">
              <div>
                <h2 className="text-2xl font-bold text-gray-800">
                  {selectedPlan.plan_name}
                </h2>
                <p className="text-gray-600 mt-2">{selectedPlan.plan_desc}</p>
              </div>

              <div className="bg-gray-50 border rounded-xl p-5 space-y-4">
                <div className="flex justify-between">
                  <span>
                    Setup Fee{" "}
                    <span className="text-sm text-gray-500">(One-Time)</span>
                  </span>
                  <span className="font-semibold">
                    ₹ {parseFloat(selectedPlan.setup_fee || 0).toFixed(2)}
                  </span>
                </div>

                <div className="flex justify-between">
                  <span>Plan Fee</span>
                  <span className="font-semibold">
                    ₹ {parseFloat(selectedPlan.plan_price || 0).toFixed(2)}/mo.
                  </span>
                </div>

                <div className="border-t pt-4 flex justify-between font-bold text-lg">
                  <span>Total Fee</span>
                  <span>
                    ₹ {parseFloat(selectedPlan.total_price || 0).toFixed(2)}
                  </span>
                </div>
              </div>

              <div>
                <h3 className="font-semibold text-lg mb-3">Features</h3>

                <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-2">
                  {selectedPlan.features
                    ?.filter((f) => f.status === "Y")
                    .map((feature, i) => (
                      <li key={i} className="flex items-start gap-2">
                        <img src={greentick} className="w-5 h-5 mt-1" alt="" />
                        <span>{feature.feature_name}</span>
                      </li>
                    ))}
                </ul>
              </div>

              <button
                onClick={openBuyPlanForm}
                className="w-[150px] bg-green-600 hover:bg-green-700 text-white py-3 rounded-xl transition"
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Buy Plan Registration From Screen */}
      {showBuyPlanForm && !showTrialForm && !showBuyPlanDetails && (
        <div className="vertical-height-100 gredient-bg min-h-screen flex justify-center items-center px-4">
          <div className="buyplandetails-container w-full max-w-2xl bg-white rounded-xl shadow-xl overflow-hidden">
            <form onSubmit={handleBuyplanFormContinue}>
              {/* Header */}
              <div className="buyplandetails-header bg-green-600 text-white text-center py-4 text-xl font-semibold">
                Fill Your Details to Continue
              </div>

              <div className="buyplanRegistration-content p-6 space-y-6">
                {/* STEP 1 */}
                {buyplanFormStep === 1 && (
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                    <div>
                      <label className="buyplan-label text-sm font-medium">
                        First Name
                      </label>
                      <input
                        type="text"
                        name="buyplanFirstName"
                        value={buyplanFormData.buyplanFirstName}
                        onChange={handleBuyplanInputChange}
                        className="buyplan-input w-full mt-1 px-4 py-2 border rounded-md focus:ring-2 focus:ring-green-500 outline-none"
                      />
                    </div>

                    <div>
                      <label className="buyplan-label text-sm font-medium">
                        Last Name
                      </label>
                      <input
                        type="text"
                        name="buyplanLastName"
                        value={buyplanFormData.buyplanLastName}
                        onChange={handleBuyplanInputChange}
                        className="buyplan-input w-full mt-1 px-4 py-2 border rounded-md focus:ring-2 focus:ring-green-500 outline-none"
                      />
                    </div>

                    <div className="lg:col-span-2">
                      <label className="buyplan-label text-sm font-medium">
                        Email
                      </label>
                      <input
                        type="email"
                        name="buyplanEmail"
                        value={buyplanFormData.buyplanEmail}
                        onChange={handleBuyplanInputChange}
                        className="buyplan-input w-full mt-1 px-4 py-2 border rounded-md focus:ring-2 focus:ring-green-500 outline-none"
                      />
                    </div>

                    <div>
                      <label className="buyplan-label text-sm font-medium">
                        Country
                      </label>
                      <select
                        name="countryCode"
                        value={buyplanFormData.countryCode}
                        onChange={handleBuyplanInputChange}
                        className="buyplan-input w-full mt-1 px-4 py-2 border rounded-md"
                      >
                        <option value="+91">+91</option>
                        <option value="+1">+1</option>
                      </select>
                    </div>

                    <div>
                      <label className="buyplan-label text-sm font-medium">
                        Mobile Number
                      </label>
                      <input
                        type="text"
                        name="mobileNo"
                        maxLength="10"
                        value={buyplanFormData.mobileNo}
                        onChange={handleBuyplanInputChange}
                        className="buyplan-input w-full mt-1 px-4 py-2 border rounded-md"
                      />
                    </div>

                    <div>
                      <label className="buyplan-label text-sm font-medium">
                        Date of Birth
                      </label>
                      <input
                        type="date"
                        name="buyplanDob"
                        value={buyplanFormData.buyplanDob}
                        onChange={handleBuyplanInputChange}
                        className="buyplan-input w-full mt-1 px-4 py-2 border rounded-md"
                      />
                    </div>

                    <div>
                      <label className="buyplan-label text-sm font-medium">
                        Gender
                      </label>
                      <select
                        name="buyplanGender"
                        value={buyplanFormData.buyplanGender}
                        onChange={handleBuyplanInputChange}
                        className="buyplan-input w-full mt-1 px-4 py-2 border rounded-md"
                      >
                        <option value="">Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                  </div>
                )}

                {/* STEP 2 */}
                {buyplanFormStep === 2 && (
                  <div className="space-y-4">
                    <h4 className="text-lg font-semibold">
                      Set up your password
                    </h4>

                    <input
                      type="password"
                      name="buyplanPassword"
                      placeholder="Password"
                      value={buyplanFormData.buyplanPassword}
                      onChange={handleBuyplanInputChange}
                      className="buyplan-input w-full px-4 py-2 border rounded-md"
                    />

                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      name="buyplanConfirmPassword"
                      placeholder="Confirm Password"
                      value={buyplanFormData.buyplanConfirmPassword}
                      onChange={handleBuyplanInputChange}
                      className="buyplan-input w-full px-4 py-2 border rounded-md"
                    />

                    <div className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        checked={showConfirmPassword}
                        onChange={toggleShowConfirmPassword}
                      />
                      <span>Show Password</span>
                    </div>
                  </div>
                )}

                {/* STEP 3 */}
                {buyplanFormStep === 3 && (
                  <div className="space-y-4">
                    <h4 className="text-lg font-semibold">OTP Verification</h4>

                    <div className="text-gray-500 text-sm">
                      OTP has been Sent to {buyplanFormData.mobileNo}
                    </div>

                    <input
                      type="text"
                      name="otp"
                      placeholder="Please Enter OTP"
                      value={buyplanFormData.otp}
                      onChange={handleBuyplanInputChange}
                      className="buyplan-input w-full px-4 py-2 border rounded-md"
                    />
                  </div>
                )}

                {/* Buttons */}
                <div className="flex gap-4 pt-4">
                  {buyplanFormStep === 2 && (
                    <button
                      type="button"
                      onClick={handleBuyplanFormBack}
                      className="px-6 py-2 border border-gray-400 rounded-md hover:bg-gray-100 transition"
                    >
                      Back
                    </button>
                  )}

                  {buyplanFormStep !== 3 && (
                    <button
                      type="submit"
                      className="px-6 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition"
                    >
                      {buyplanFormStep === 1 ? "Continue" : "Send OTP"}
                    </button>
                  )}

                  {buyplanFormStep === 3 && (
                    <button
                      type="button"
                      onClick={handleOTPVerification}
                      className="px-6 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition"
                    >
                      Verify OTP
                    </button>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
    </>
  );
};

export default BuyPlan;
